export const VolusionPaymentsKYCModelModule = angular
    .module('app.services.model.models.volusionPaymentsKYCModel', [])
    .value('volusionPaymentsKYCModel', {
        tenant: 'String',
        subscriptionId: 'String',
        business_identity: {
            business_name: 'String',
            business_type: 'String',
            employer_id_number: 'String',
            business_website: 'String',
            business_phone: {
                country_code: ['String', '+1'],
                phone_number: 'String'
            },
            address: {
                address1: 'String',
                address2: 'String',
                city: 'String',
                postal_code: 'String',
                region: 'String',
                country: ['String', 'US']
            }
        },
        about_business: {
            business_description: 'String',
            years_in_business: 'Number',
            average_delivery: 'String',
            average_order: 'Number',
            annual_sales: 'String'
        },
        owner: {
            owner_name: {
                title: 'String',
                first: 'String',
                last: 'String'
            },
            owner_address: {
                address1: 'String',
                address2: 'String',
                city: 'String',
                postal_code: 'String',
                region: 'String',
                country: ['String', 'US']
            },
            ownership_type: 'String',
            owner_years_at_address: 'Number',
            email: 'String',
            owner_phone: {
                country_code: ['String', '+1'],
                phone_number: 'String'
            },
            date_of_birth: {
                year: 'Number',
                month: 'Number',
                day: 'Number'
            },
            social_security_number: 'String'
        },
        card_statement: {
            billing_statement_descriptor: 'String',
            customer_service_phone: {
                country_code: ['String', '+1'],
                phone_number: 'String'
            }
        },
        banking: {
            routing_number: 'String',
            account_number: 'String',
            terms_of_service: ['Boolean', false]
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/services/data/model/models/volusionPaymentsKYC.model.js